export default __webpack_public_path__ + "static/media/deleteIC.13895457.svg";